<!--
 * @Author: 张天昊
 * @Date: 2024-05-22 15:57:23
 * @LastEditTime: 2024-06-24 13:50:06
 * @LastEditors: 张天昊
 * @Description: 链接container
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/WithLink.vue
-->
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    inline: {
      type: Boolean,
      default: true
    },
    gutter: {
      type: Boolean
    }
  },
  setup(_, { emit }) {
    function onClick() {
      emit('click');
    }
    return {
      onClick
    };
  }
});
</script>

<template>
  <div
    :class="[inline ? 'inline-flex' : 'flex']"
    class="relative items-center van-haptics-feedback"
    @click.stop="onClick"
  >
    <slot></slot>
    <slot name="link">
      <div
        class="w-12 h-12 bg-board-a rounded-full flex items-center justify-center flex-shrink-0"
        :class="{ 'ml-4': gutter }"
      >
        <svg-icon
          pre-path="itineraryUniversal"
          name="ic-arrow"
          class="text-black-primary stroke-black-primary w-10 h-10"
        />
      </div>
    </slot>
  </div>
</template>
